<div class="screen flex flex-col relative">
    <app-header />

    <section class="grow py-[1.25rem] mx-3 | md:mx-5 md:py-[3.25rem] | 3xl:container 3xl:mx-auto">
        <router-outlet />
    </section>

    <app-footer />
</div>
